<script lang="ts" setup>
import type { PartName } from '@autobid/ui/composables/car/useDetailsPart'
import type { DetailsCarPart } from '@autobid/ui/types/components/CarDetails'
import { useDetailsPart } from '@autobid/ui/composables/car/useDetailsPart'

interface Props {
  partName: PartName
  part?: DetailsCarPart
}

const props = defineProps<Props>()

const { shouldBeRendered, list, freeText, labels } = useDetailsPart(
  props.partName,
  props.part,
)
</script>

<template>
  <tr v-if="shouldBeRendered && part">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading as="th">
            {{ labels.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <tr>
            <td class="pt-1.5">
              <table class="w-full border-collapse">
                <SectionsDetailsElementsTable :table="part.table" />
              </table>
            </td>
          </tr>

          <tr v-if="part.images?.length">
            <td>
              <SectionsDetailsElementsPartImageTable
                :title="labels.photos"
                :images="part.images"
              />
            </td>
          </tr>

          <tr v-if="list.length">
            <td>
              <p class="mb-1 font-semibold">
                {{ labels.list }}:
              </p>
              <p>{{ list }}</p>
            </td>
          </tr>

          <SectionsDetailsPdfElementsFreeText
            v-if="freeText?.length"
            :has-border="list.length > 0"
            :free-text="freeText"
          />
        </tbody>
      </table>
    </td>
  </tr>
</template>
